import styled from 'styled-components'
import { Form } from 'antd'

export const StyleForm = styled(Form)`
  padding-bottom: 20px;
`

export const QuestionItem = styled.div<{ depth?: number }>`
  padding-left: ${(props) => (props.depth ? props.depth * 20 : 0)}px;
  position: relative;
  transition: all 0.3s ease-in-out;

  ${(props) =>
    props.depth &&
    props.depth > 0 &&
    `
    &::before {
      content: '';
      position: absolute;
      left: ${(props.depth - 1) * 20 + 10}px;
      top: 0;
      bottom: 0px;
      width: 1px;
      background-color: var(--color-yuma);
      opacity: 0.3;
    }
  `}

  &.is-hidden {
    height: 0;
    overflow: hidden;
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0;
    margin-bottom: 0;
    opacity: 0;
    pointer-events: none;
  }

  .q-title {
    /* background-color: #f1efe7; */
    margin: 10px 15px;
    font-size: 14px;
    word-break: break-all;
    margin-bottom: 1.5rem;
    font-weight: 500;
    border-bottom: 1px solid var(--color-rangoon-green);
    padding-bottom: 5px;

    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .q-left {
    flex: 1;
    white-space: pre-wrap;
  }

  .required {
    border: 1px solid var(--color-mandys-pink);
    padding: 3px 7px 0;
    color: var(--color-white);
    background-color: var(--color-mandys-pink);
    font-size: 11px;
    flex-shrink: 0;
    font-weight: 700;
  }

  .q-wrap {
    display: block;
    text-align: center;
    font-weight: 500;
    padding: 15px 10px 1.5rem 10px;
  }

  .btn-q {
    display: none;
  }

  .label-q {
    background-color: #fff;
    color: #000;
    font-size: 12px;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.25rem;
    margin-bottom: 10px;

    &.inactive {
      pointer-events: none;
    }

    .inactive {
      background-color: #ccc;
      border-color: #999;
      color: #eee;
      opacity: 1;
      cursor: default;
      pointer-events: none;

      &:hover {
        background-color: #ccc !important;
      }
    }

    @media (min-width: 768px) {
      &:hover {
        opacity: 0.7;
      }
    }
  }

  input.btn-q + span {
    background-color: var(--color-spring-wood);
    /* border: 1px solid #000; */
    color: #000;
    font-size: 12px;
    width: 100%;
    text-align: center;
    margin: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px !important;
    border-radius: 0.25rem;
  }

  input.btn-q:checked + span {
    background-color: var(--color-yuma);
    color: #fff;
    border-color: #fff;
    font-size: 12px;
    width: 100%;
    text-align: center;
    margin: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px !important;
    border-radius: 0.25rem;
  }

  .question-input {
    background-color: #fff;
    border: 1px solid #000;
    border-radius: 5px;

    &.inactive {
      background: #ccc;
      border: 1px solid #000;
      opacity: 1;
      cursor: none;

      &:hover {
        background-color: #ccc !important;
      }
    }
  }

  &.has-error {
    background-color: #ffe6e6;
    border: 1px solid #ff4d4f;
  }
`
